var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAward = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "award__a",
  d: "M12 2.91a6.227 6.227 0 0 1 5.378 9.368l3.742 7.426-3.99-.998-1.935 2.903-2.91-6.252a6.333 6.333 0 0 1-.57 0l-2.91 6.252-1.935-2.903-3.99.998 3.742-7.426A6.227 6.227 0 0 1 12 2.908Zm4.721 10.287a6.224 6.224 0 0 1-3.395 2.025l2.024 4.35 1.339-2.006 2.555.638Zm-9.442 0-2.524 5.007 2.556-.638 1.338 2.006 2.026-4.35a6.224 6.224 0 0 1-3.396-2.025ZM12 3.91a5.227 5.227 0 1 0 0 10.455 5.227 5.227 0 0 0 0-10.455ZM12 7a2.136 2.136 0 1 1 0 4.273A2.136 2.136 0 0 1 12 7Zm0 1a1.136 1.136 0 1 0 0 2.273A1.136 1.136 0 0 0 12 8Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "award__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#award__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#award__a",
  fill: "#7F7F7F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#award__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAward);
export default ForwardRef;